import { useEffect, useState } from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { CustomEvents } from 'shared/constants/customEvents'
import { useActiveApp } from 'shared/hooks/useActiveApp'

const NullModal = () => null

export const SubmitRequestModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const activeAppPath = useActiveApp()?.app.path

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_FEEDBACK_APP_DEV_PATH,
    'feedback',
    './SubmitRequestModal',
    'feedbackApp',
    false,
    process.env.REACT_APP_FEEDBACK_APP_CDN_URL
  )

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return

      if (event.data?.type === CustomEvents.OPEN_SUBMIT_REQUEST_MODAL) {
        setIsOpen(true)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  // @ts-expect-error: dynamic import
  const { SubmitRequestModal: SubmitRequestModalComponent } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { SubmitRequestModal: NullModal }

  if (!SubmitRequestModalComponent) {
    return null
  }

  return (
    <SubmitRequestModalComponent
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      activeAppPath={activeAppPath}
    />
  )
}
